import React, { createContext} from "react";

  const UserNameContext = createContext();
  export default UserNameContext;